import { Container, Row, Col, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Home, Users, Mail, Truck, Phone, MapPin, Clock, ChevronRight } from 'lucide-react';
import { FaWhatsapp, FaFacebook, FaInstagram, FaTiktok, FaYoutube } from 'react-icons/fa';
import logo1 from '../../assets/img/logo.png';
import truper from '../../assets/img/footer/Truper2.png';
import pretul from '../../assets/img/footer/Pretul2.png';
import foset from '../../assets/img/footer/Foset2.png';
import volteck from '../../assets/img/footer/Volteck2.png';
import fiero from '../../assets/img/footer/Fiero2.png';
import hermex from '../../assets/img/footer/Hermex2.png';
import klintek from '../../assets/img/footer/Klintek2.png';

function Footer() {
    const currentYear = new Date().getFullYear();
    
    const quickLinks = [
        { icon: <Home size={16} />, text: "Inicio", href: "/" },
        { icon: <Users size={16} />, text: "Nosotros", href: "/about" },
        { icon: <Mail size={16} />, text: "Contacto", href: "/contacto" },
        { icon: <Truck size={16} />, text: "Ser Distribuidor", href: "/distribuidor" }
    ];

    const marcasLogos = [
        { src: truper, alt: "Truper"},
        { src: pretul, alt: "Pretul" },
        { src: foset, alt: "Foset" },
        { src: volteck, alt: "Volteck" },
        { src: fiero, alt: "Fiero" },
        { src: hermex, alt: "Hermex" },
        { src: klintek, alt: "Klintek" }
    ];

    const socialLinks = [
        { 
            icon: <FaWhatsapp size={24} />, 
            href: "http://wa.me/59178311061", 
            label: "WhatsApp",
            color: "#25D366"
        },
        { 
            icon: <FaFacebook size={24} />, 
            href: "https://www.facebook.com/SALCEDOIMPORTACIONES", 
            label: "Facebook",
            color: "#1877F2"
        },
        { 
            icon: <FaInstagram size={24} />, 
            href: "https://www.instagram.com/truperbolivia.salcedoimpor/", 
            label: "Instagram",
            color: "#E4405F"
        },
        { 
            icon: <FaTiktok size={24} />, 
            href: "https://www.tiktok.com/@truper.bolivia.sa3", 
            label: "TikTok",
            color: "#000000"
        },
        { 
            icon: <FaYoutube size={24} />, 
            href: "https://www.youtube.com/", 
            label: "YouTube",
            color: "#FF0000"
        }
    ];

    const contactInfo = [
        { 
            icon: <Mail size={18} />, 
            text: "ventas@salcedoimport.com",
            href: "mailto:atencionalcliente@salcedoimport.com"
        },
        { 
            icon: <Phone size={18} />, 
            text: "4-233082 | 4-544825"
        },
        { 
            icon: <Phone size={18} />, 
            text: "75986800"
        },
        { 
            icon: <MapPin size={18} />, 
            text: "Av. Villazon Km. 5 Sacaba, Cochabamba - Bolivia"
        }
    ];

    return (
        <footer className="footer-section">
            {/* Decoración de onda superior */}
            <div className="footer-wave">
                <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
                </svg>
            </div>

            <Container className="footer-container">
                {/* Footer Principal */}
                <Row className="footer-main g-5">
                    {/* Columna 1: Logo y Enlaces */}
                    <Col lg={3} md={6}>
                        <div className="footer-column">
                            <div className="footer-logo-section">
                                <img 
                                    src={logo1} 
                                    alt="Salcedo Importaciones Logo" 
                                    className="footer-logo"
                                />
                                <p className="footer-description">
                                    Líderes en importación y distribución de herramientas profesionales en Bolivia.
                                </p>
                            </div>

                            <Nav className="footer-nav">
                                {quickLinks.map((link, index) => (
                                    <Nav.Link 
                                        key={index} 
                                        href={link.href} 
                                        className="footer-nav-link"
                                    >
                                        <span className="nav-icon">{link.icon}</span>
                                        <span className="nav-text">{link.text}</span>
                                        <ChevronRight size={14} className="nav-arrow" />
                                    </Nav.Link>
                                ))}
                            </Nav>
                        </div>
                    </Col>

                    {/* Columna 2: Marcas */}
                    <Col lg={3} md={6}>
                        <div className="footer-column">
                            <h3 className="footer-title">Nuestras Marcas</h3>
                            <div className="footer-marcas-grid">
                                {marcasLogos.map((marca, index) => (
                                    <div 
                                        key={index} 
                                        className="marca-logo-item"
                                        style={{ animationDelay: `${index * 0.1}s` }}
                                    >
                                        <img 
                                            src={marca.src} 
                                            alt={marca.alt}
                                            className="marca-logo-img"
                                        />
                                    </div>
                                ))}
                            </div>
                            {/* <a href="/showroom" className="footer-link-cta">
                                Ver todas las marcas
                                <ChevronRight size={16} />
                            </a> */}
                        </div>
                    </Col>

                    {/* Columna 3: Contacto */}
                    <Col lg={3} md={6}>
                        <div className="footer-column">
                            <h3 className="footer-title">Contáctanos</h3>
                            <div className="footer-contact-list">
                                {contactInfo.map((info, index) => (
                                    <div key={index} className="contact-item">
                                        <div className="contact-icon">
                                            {info.icon}
                                        </div>
                                        <div className="contact-text">
                                            {info.href ? (
                                                <a href={info.href} className="contact-link">
                                                    {info.text}
                                                </a>
                                            ) : (
                                                <span>{info.text}</span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Col>

                    {/* Columna 4: Horarios */}
                    <Col lg={3} md={6}>
                        <div className="footer-column">
                            <h3 className="footer-title">Horarios de Atención</h3>
                            <div className="footer-horarios">
                                <div className="horario-item">
                                    <div className="horario-icon">
                                        <Clock size={24} />
                                    </div>
                                    <div className="horario-content">
                                        <h4 className="horario-day">Lunes a Viernes</h4>
                                        <p className="horario-time">08:00 - 12:00 | 14:00 - 18:00</p>
                                    </div>
                                </div>
                                <div className="horario-item">
                                    <div className="horario-icon">
                                        <Clock size={24} />
                                    </div>
                                    <div className="horario-content">
                                        <h4 className="horario-day">Sábados</h4>
                                        <p className="horario-time">08:00 - 12:00</p>
                                    </div>
                                </div>
                            </div>

                            {/* Redes Sociales */}
                            <div className="footer-social-section">
                                <h4 className="social-title">Síguenos</h4>
                                <div className="social-links">
                                    {socialLinks.map((social, index) => (
                                        <a 
                                            key={index}
                                            href={social.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="social-link"
                                            aria-label={social.label}
                                            style={{ '--social-color': social.color }}
                                        >
                                            {social.icon}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Footer Bottom */}
                <div className="footer-bottom">
                    <div className="footer-bottom-content">
                        <p className="copyright-text">
                            &copy; {currentYear} <strong>Salcedo Importaciones S.R.L.</strong> Todos los derechos reservados
                        </p>
                        <div className="footer-links">
                            <Link to="/politica-privacidad" className="footer-link">Política de Privacidad</Link>
                            <span className="separator">|</span>
                            {/* <Link to="/terminos" className="footer-link">Términos y Condiciones</Link> */}
                        </div>
                    </div>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;